<div *ngIf="Provider" class="provider-item-element">
    <div class="provider-item " (click)="navigateTo(Provider)">
        <img [src]=[Provider.WebFilePath] class="responsive-img" />
        <p class="break-word" [ngStyle]="{'color': Provider.Name == 'EVOCABANK' ? '#6400DC' : '' }"> {{Provider.Name}} </p>
    </div>
</div>